(function() { window.GUID_dbfb0ea6_01ce_4468_b382_4a034acc73a9 = { getGuid: function() { return "dbfb0ea6-01ce-4468-b382-4a034acc73a9"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class CreditCard extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
                this.publicKey = params[1];
                this.locale = params[2];
                if (params.length > 2) {
                    this.publicKey2 = params[3];
                }
                let me = this;
                if (!$('.new-card').hasClass('hidden')) {
                    me.loadScript();
                }
                $('#button-use-new-card').on('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $('.new-card').removeClass('hidden');
                    $('.previous-cards').hide();
                    var checkbox = CS.Controls.GetInstance(CS.Controls.CheckBox, '#checkbox-existing');
                    checkbox.SetValue(false);
                    me.loadScript();
                    return false;
                });
            }
            OnDispose() {
                this.$Control.remove();
            }
            OnBindEvents() { }
            setBrandIcon(brand) {
                const cardBrandToPfClass = {
                    'visa': 'pf-visa',
                    'mastercard': 'pf-mastercard',
                    'amex': 'pf-american-express',
                    'discover': 'pf-discover',
                    'diners': 'pf-diners',
                    'jcb': 'pf-jcb',
                    'unknown': 'pf-credit-card',
                };
                const brandIconElement = document.getElementById(this.ControlId + '-brand-icon');
                let pfClass = 'pf-credit-card';
                if (brand in cardBrandToPfClass) {
                    pfClass = cardBrandToPfClass[brand];
                }
                for (let i = brandIconElement.classList.length - 1; i >= 0; i--) {
                    brandIconElement.classList.remove(brandIconElement.classList[i]);
                }
                brandIconElement.classList.add('pf');
                brandIconElement.classList.add(pfClass);
            }
            MakePayment(useCurrentCardCallback, useNewCardCallback) {
                return __awaiter(this, void 0, void 0, function* () {
                    let checkbox = null;
                    try {
                        checkbox = CS.Controls.GetInstance(CS.Controls.CheckBox, '#checkbox-existing');
                    }
                    catch (_a) { }
                    if (checkbox != null && checkbox.IsChecked) {
                        useCurrentCardCallback($('#cardInfoId').val());
                    }
                    else {
                        yield this.onMakePaymentNewCard(useNewCardCallback);
                    }
                });
            }
            static GetInstance(selector) {
                let cc = CS.Controls.GetInstance(CS.Controls.StripeCreditCard, selector, true);
                if (cc) {
                    return cc;
                }
                let scc = CS.Controls.GetInstance(CS.Controls.SquareCreditCard, selector);
                return scc;
            }
        }
        Controls.CreditCard = CreditCard;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=credit-card.js.map
